<template>
  <Upload
    v-model:file-list="fileList"
    action="http://front.jms.com/oss/oss-upload"
    name="file"
    :max-count="props.maxCount"
  >
    <Button>
      <upload-outlined></upload-outlined>
      Upload
    </Button>
  </Upload>
</template>
<script lang="ts" setup name="SmartUpload">
import { Button, Upload } from 'ant-design-vue'
import { ref } from 'vue'
import { UploadOutlined } from '@ant-design/icons-vue'
import type { UploadProps } from 'ant-design-vue'
const props = defineProps({
  maxCount: {
    type: Number,
    default: 1
  }
})
const fileList = ref<UploadProps['fileList']>([])
</script>
